import HeroSection from "../../Components/Organisms/Job/HeroSection";
import ContactsSection from "../../Components/Organisms/Job/ContactsSection";
import { Navigate, useParams } from "react-router-dom";

import jobs from "../../Assets/Lang/en/careers/careers.json";

const JobPage = () => {
	const params = useParams();

	if (jobs[params.jobId])
		return (
			<div>
				<HeroSection {...jobs[params.jobId]} />
				<ContactsSection />
			</div>
		);
	else return <Navigate to="/careers" />;
};

export default JobPage;
